import jwt_decode from "jwt-decode";
import {decriptMessage} from "./SecureData";

export function verifyTokenValidity(application, requiredRole) {
	let token = sessionStorage.getItem("key_asl_to");
	let result = false;
	if (token) {
		let decripted = decriptMessage(token);
		let decoded = jwt_decode(decripted);
		if (decoded) {
			if (requiredRole && decoded.roles && (decoded.roles.includes("ROLE_ADMIN") || decoded.roles.includes("ROLE_OPERATOR") || decoded.roles.includes("ROLE_COMPANY") || checkIfContains(decoded.roles))) {
				let applicationPermitted = decoded.application;
				let expiredDate = new Date(decoded.exp * 1000);
				let notBeforeClaimDate = new Date(decoded.nbf * 1000);
				if (checkDateToken(expiredDate, notBeforeClaimDate)) {
					if (applicationPermitted === application) {
						result = true;
					}
				}
			} else if (!requiredRole) {
				let applicationPermitted = decoded.application;
				let expiredDate = new Date(decoded.exp * 1000);
				let notBeforeClaimDate = new Date(decoded.nbf * 1000);
				if (checkDateToken(expiredDate, notBeforeClaimDate)) {
					if (applicationPermitted === application) {
						result = true;
					}
				}
			}
		}
	}
	return result;
}

export function checkIfContains(roles) {
	let ok = false;
	roles.forEach(role => {
		if (role && (role.includes("AO") || role.includes("SP"))) {
			ok = true
		}
	})
	return ok;
}

function checkDateToken(exp, nbf) {
	let now = new Date();
	return !(now >= exp && now >= nbf);
}
